// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1_Hzs","label":"Category_label__Sqn9G","content":"Category_content__-u-Sc","header":"Category_header__8sl7i","location":"Category_location__3tkM_"};